<template>
  <div class="news-list">
    <svg id="news-line" xmlns="http://www.w3.org/2000/svg" width="1110" height="2.758" viewBox="0 0 1110 2.758">
  <path id="Path_3805" data-name="Path 3805" d="M68.064,8.828c319.278-1.082,642.638.1,963.423-.594,81.313-.175,128.708-2.341,19.2-2.105-320.867.691-643.542-.49-963.423.594C7.792,6.992-41,9.2,68.064,8.828Z" transform="translate(-4.75 -6.112)" fill="#3a5aa7" opacity="0.2"/>
</svg>

<div class="container-bar filter-row">
  <span class="f-21 bold-italic filter-label">{{ $fn.tr('დაალაგე') }}:</span>
  <el-select v-model="filterVal" placeholder="" :popper-append-to-body="false">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="$fn.tr('თარიღით')"
      :value="item.value"
      
      >
    </el-option>
  </el-select>
</div>
      <div class="news-list-inner-wrapper container-bar">
       

         <router-link :to="$store.getters['main/getSingleUrl'](news)" class="news-list-box" v-for="(news, index) in getContent" :key="index">
            <div class="news-list-box-img-wrapper">
                 <img :src="news.cover[0].url" :alt="get_alt(news)" > 
            </div>
          
           <div class="news-list-box-text-block">
               <span class="f-21 to-lowercase">{{date(news.date)}}</span>
               <!-- <div class="news-desc" v-html="news.teaser"></div> -->
               <h2 class="news-desc f-21 bold">{{news.title}}</h2>
               <a href="#" class="read-more">
                   <svg xmlns="http://www.w3.org/2000/svg" width="23.088" height="17.048" viewBox="0 0 23.088 17.048">
  <g id="Group_375" data-name="Group 375" transform="translate(25.3 -3.214)">
    <g id="menu" transform="translate(-24.753 3.741)">
      <g id="Group_103" data-name="Group 103" transform="translate(0 0)">
        <path id="Union_6" data-name="Union 6" d="M10.186,13.528a42.026,42.026,0,0,1,5.327-3.78c.514-.31,1.042-.606,1.584-.864-.785-.032-1.585,0-2.378.035-.842.037-1.674.07-2.469.031C8.82,8.766,5.424,8.13,1.98,8.2.8,8.221-1.146,6.422.861,6.382c3.9-.078,7.731.7,11.624.784.645.011,1.3,0,1.972-.021a21.057,21.057,0,0,1,4.4.208c-1.921-2.05-4.121-3.827-5.775-6.129-.5-.689-.1-1.825.578-.877,1.991,2.776,4.788,4.795,6.924,7.444a1.141,1.141,0,0,1,.178.309.913.913,0,0,1,.281.694c0,.031,0,.059,0,.086-.018.523-.753.631-1.488.459a10.106,10.106,0,0,0-3.842,1.793,47.276,47.276,0,0,0-4.389,3.181,1,1,0,0,1-.644.218C10.078,14.532,9.532,14.076,10.186,13.528Z" transform="matrix(0.998, -0.07, 0.07, 0.998, 0, 1.491)" fill="#101820" stroke="#101820" stroke-width="1"/>
      </g>
    </g>
  </g>
</svg>
<span class="f-16">{{ $fn.tr('ვრცლად') }}</span>
               </a>
           </div>
      </router-link>

     

      </div>
      <div class="show-more"  @click="showMore()" v-if="this.getContent.length < listCount">
          <span class="f-30">{{ $fn.tr('მეტის ჩვენება') }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="22.988" height="31.675" viewBox="0 0 22.988 31.675">
  <g id="Group_104" data-name="Group 104" transform="translate(26.193 25.292) rotate(90)">
    <g id="menu" transform="translate(-24.754 3.74)">
      <g id="Group_103" data-name="Group 103" transform="translate(0 0)">
        <path id="Union_6" data-name="Union 6" d="M14.188,18.549a58.283,58.283,0,0,1,7.4-5.171c.715-.424,1.448-.829,2.2-1.182-1.091-.045-2.205,0-3.308.045-1.171.049-2.329.094-3.434.039-4.772-.258-9.5-1.134-14.285-1.043-1.647.027-4.351-2.44-1.56-2.492,5.429-.1,10.753.977,16.168,1.092.9.017,1.815,0,2.742-.025a29.737,29.737,0,0,1,6.123.291C23.565,7.291,20.5,4.854,18.2,1.7c-.692-.945-.142-2.5.8-1.2,2.773,3.807,6.667,6.576,9.641,10.209a1.562,1.562,0,0,1,.248.424,1.243,1.243,0,0,1,.392.951c0,.042,0,.081,0,.118-.024.716-1.047.863-2.069.626a14.12,14.12,0,0,0-5.341,2.45,65.534,65.534,0,0,0-6.1,4.352,1.4,1.4,0,0,1-.9.3C14.039,19.925,13.278,19.3,14.188,18.549Z" transform="matrix(0.998, -0.07, 0.07, 0.998, 0, 2.043)" fill="#044b30" stroke="#044b30" stroke-width="1"/>
      </g>
    </g>
  </g>
</svg>

      </div>
  </div>
</template>

<script>
import fn from "../../helpers/func";
import moment from "../../helpers/moment";
export default {
  props: ['contentData'],
data(){
    return{
      origNewsList: this.$store.state.main.newsList,
        options: [{
          value: 'sortByDate',
        }],
       getContent: _.get(this.contentData, 'data.list'),
       pageCounter: 1,
       
      filterVal: '',
        // newsToShow: 4,
        byDate: '',
        byDates: [],
        
    }
},
computed: {
    listCount(){
      return _.get(this.contentData, 'data.listCount');
    },
    newsToShow(){
      return parseInt(_.get(this.contentData, "conf.page_count"))
        ? parseInt(_.get(this.contentData, "conf.page_count"))
        : 4;
    },

    newsList(){
      let news = this.$store.state.main.newsList;
      for (let i = 0; i < news.length; i++) {
        //let formattedDate = moment(news[i].dateAdded).format("DD.MM.YYYY");
        let formattedDate = new Date(news[i].dateAdded);
        news[i].dateAdded = formattedDate;
        // return news;

     
           
      }
       
       if(this.filterVal === 'sortByDate'){
         console.log("hey")
        news = news.slice(0, this.newsToShow).sort(this.compare);
        // news = news.sort(this.compare);
        console.log(news.slice(0, this.newsToShow).sort(this.compare))
       }  
       
        return news.slice(0, this.newsToShow);
    },

    
    remainder(){
        if(this.origNewsList.length - this.newsToShow <= this.newsToShow){
            return this.origNewsList.length - this.newsToShow;
        } else {
            return 4;
        }
       
       
    }
},

methods: {
   get_alt(content){
      if(content.seo_title_ge && this.$store.state.main.locale == 'ge'){
        return content.seo_title_ge;
      } else if (content.seo_title_ge && this.$store.state.main.locale == 'en'){
        return content.seo_title_en;

      } else {
          return ' ';
      }
    },
  compare(a, b) {
      if (new Date(a.date) > new Date(b.date)) return -1
      else if (new Date(a.date) < new Date(b.date)) return 1
      else return 0
    },
    date(dateParam){
         if(this.$route.name === 'ge') moment.locale('ka');
              
         if(this.$route.name == 'ge'){
         
           return  moment(dateParam).locale('ka').format("DD MMM YYYY");
         } else if(this.$route.name == 'en'){
         
         return  moment(dateParam).locale('en').format("DD MMM YYYY");
        }
        
        
      
      

    },
    async showMore(){
    
      setTimeout(() => {
          this.$store.commit("main/updateLsStatus", !this.$store.state.main.updateLs);
      }, 500);
      setTimeout(() => {
          this.$store.commit("main/updateLsStatus", !this.$store.state.main.updateLs);
      }, 600);
     this.pageCounter += 1;  
     let params = {
          id: _.get(this.$store.state.main.selected_menu, "id"),
        pageNumber: this.pageCounter,
        componentUnicId: _.get(this.contentData, "conf.unicId"),
     };
     
     let res = await fn.postData('main/getDataList', params);
     console.log(res)
     this.getContent = this.getContent.concat(res.data.list);
     if(this.filterVal) this.getContent = this.getContent.sort((a, b) => new Date(b.date) - new Date(a.date));
      
    }
},
mounted(){
   
   console.log(this.listCount)
  this.$store.state.main.scrollToTop = !this.$store.state.main.scrollToTop;
   this.$nextTick(() => {
     this.$store.state.main.updateLs3 = !this.$store.state.main.updateLs3;
     
  
   })
   this.$store.state.main.scrollToTop = !this.$store.state.main.scrollToTop;
    console.log(this.newsList)
    this.$store.state.main.reloadOurStories = !this.$store.state.main.reloadOurStories
  
},

updated(){
 
  
},
watch: {
  '$route'(to, from){
     if(window.innerWidth >= 1024){
     this.$store.state.main.scrollToTop = !this.$store.state.main.scrollToTop;
      this.$store.state.main.updateLs3 = !this.$store.state.main.updateLs3;
      console.log("hi")
     }
  },
  filterVal(ns, os){
    this.getContent = this.getContent.sort((a, b) => new Date(b.date) - new Date(a.date));
    console.log("hi")
    console.log(new Date(this.getContent[0].date));
  }
}
}
</script>

<style lang="scss" scoped>
.news .news-list .news-list-inner-wrapper .news-list-box-text-block .news-desc, 
.news .news-list .news-list-inner-wrapper .news-list-box-text-block span, 
.news .news-list .show-more span,
.news .filter-row .filter-label{
  will-change: transform;
}
.news .news-list .news-list-inner-wrapper .news-list-box-text-block span{
  display: inline-block;
}

</style>